module.exports = __webpack_public_path__ + "img/129.6ee8cb14.jpg";